
@switch (mode) {
  @case (LabelMode.DEFAULT) {
    <ng-container
      [ngTemplateOutlet]="default"
    ></ng-container>
  }
  @case (LabelMode.INLINE) {
    <ng-container
      [ngTemplateOutlet]="inline"
    ></ng-container>
  }
  @case (LabelMode.NO_LABEL) {
    <ng-container
      [ngTemplateOutlet]="input"
    ></ng-container>
  }
}

<ng-template #input>
  <div class="demo-inline-spacing" [ngClass]="classes">
    <div
      class="form-check form-check-inline form-check-custom form-check-sm {{
        mode === LabelMode.INLINE ? 'me-0' : ''
      }}"
      [ngClass]="InputClass"
      >
      <input
        type="checkbox"
        [id]="name"
        [name]="name"
        class="form-check-input"
        [formControl]="form"
        (change)="onInputChange($event)"
        />
      <!-- (change)="onInputChange($event.target?.checked!)" -->
      <label
        class="custom-control-label col-form-label fw-bold fs-6 py-2"
        [for]="name"
        >{{ inputLabel | translate }}</label
        >
      </div>
    </div>
  </ng-template>

  <ng-template #default>
    <div class="form-group">
      <label
        [for]="name"
        class="col-form-label fw-bold fs-6 py-2"
        [ngClass]="required ? 'required' : ''"
        >{{ label | translate }}</label
        >
        <ng-container [ngTemplateOutlet]="input"></ng-container>
      </div>
    </ng-template>

    <ng-template #inline>
      <div class="form-group form-group-inline flex-row-reverse">
        <label
          [for]="name"
          class="col-form-label fw-bold fs-6 py-2 pe-0"
          [ngClass]="required ? 'required' : ''"
          >{{ label | translate }}</label
          >
          <ng-container [ngTemplateOutlet]="input"></ng-container>
        </div>
      </ng-template>
